import classNames from "classnames";
import { HubItemRowLayoutKind } from "client/Api/Hub/common";
import { setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement
} from "react";
import { Embed } from "../Elements/Embed/Embed";
import { HorizontalLine } from "../Elements/HorizontalLine/HorizontalLine";
import { Image } from "../Elements/Image/Image";
import { Paragraph } from "../Elements/Paragraph/Paragraph";
import { Subtitle } from "../Elements/Subtitle/Subtitle";
import { Video } from "../Elements/Video/Video";
import { FrequentlyAskedQuestions } from "../Elements/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
import styles from "./ContentLayout.module.less";

export const ContentLayout = (props: PropsWithChildren<{}>): ReactElement => (
	<div className={styles.root}>
		{props.children}
	</div>
);
ContentLayout.displayName = "ContentLayout";

type ContentLayoutRowProps = {
	rowKind: HubItemRowLayoutKind;
	hasStackedColumns: boolean;
	trackingId?: string;
};

const ContentLayoutRow = (props: PropsWithChildren<ContentLayoutRowProps>) => {
	const {
		children,
		rowKind,
		hasStackedColumns,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.row,
				classNameForRowLayoutKindMap[rowKind],
				{
					[styles.stackedColumns]: hasStackedColumns
				}
			)}
		>
			{children}
		</div>
	);
};
ContentLayoutRow.displayName = "ContentLayout.Row";

const classNameForRowLayoutKindMap: {[key in HubItemRowLayoutKind]: string | undefined } = {
	[HubItemRowLayoutKind.OneColumn]: undefined,
	[HubItemRowLayoutKind.TwoColumn]: undefined,
	[HubItemRowLayoutKind.ThreeColumn]: undefined,
	[HubItemRowLayoutKind.FourColumn]: undefined,
	[HubItemRowLayoutKind.TwoColumnBigLeft]: styles.row_twoColumnBigLeft,
	[HubItemRowLayoutKind.TwoColumnBigRight]: styles.row_twoColumnBigRight
};

type ContentLayoutColumnProps = {
	trackingId?: string;
};

const ContentLayoutColumn = (props: PropsWithChildren<ContentLayoutColumnProps>) => {
	const {
		children,
		trackingId
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.column}
		>
			{children}
		</div>
	);
};
ContentLayoutColumn.displayName = "ContentLayout.Column";

ContentLayout.Row = ContentLayoutRow;
ContentLayout.Column = ContentLayoutColumn;
ContentLayout.HorizontalLine = HorizontalLine;
ContentLayout.Image = Image;
ContentLayout.Paragraph = Paragraph;
ContentLayout.Subtitle = Subtitle;
ContentLayout.Video = Video;
ContentLayout.Embed = Embed;
ContentLayout.FrequentlyAskedQuestions = FrequentlyAskedQuestions;